import RequestPasswordResetView from './RequestPasswordReset';

export default RequestPasswordResetView;
